import Navbar from 'src/components/HorizontalLayout/Navbar';
import React, { useCallback, useEffect, useRef, useState } from "react"
import { toast } from 'react-toastify';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Input,
    UncontrolledAlert,
    Collapse,
    Modal,
    ModalFooter,
    FormGroup,
    ModalBody,
    Button,
    Label,
    ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { useAgency } from 'src/components/Common/agencyBrandingData';
import { useLocation, useNavigate } from 'react-router-dom';
import { getProposals } from 'src/slices/Proposals/thunk';
import ExpandedComponent from './ExpandedComponent';
import axiosInstance from 'src/common/axiosInstance';
import PhoneInput from 'react-phone-input-2';
import { normalizePhoneNumber } from "src/helpers/phoneHelper";
import { usePageAccess, PAGE_ACCESS_TYPES } from '../../components/Common/useAuthRedirect';
import BillingCardLoader from '../../components/Common/BillingCardLoader';
import TableCustomLoader from '../../components/Common/TableCustomLoader';
import useIsMobile from 'src/hooks/useIsMobile';
import "./billing.css"
import Pagination from 'src/components/Common/Pagination';
import CustomDatePicker from 'src/common/CustomDatePicker';

interface Proposal {
    account_name: string;
    order_name_c: string;
    id: number;
    start_date: string;
    end_date: string;
    user_name: string;
    amount: number;
    status: string;
    manual_order: number;
}

type BillingContact = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    title: string;
};
const Billing = () => {
    const dispatch = useDispatch();
    const agency = useAgency();
    const navigate = useNavigate()
    const location = useLocation();
    const [titleError, setTitleError] = useState('');
    const { proposals, ProposalsError } = useSelector((state: any) => state.proposals);
    const agencyData = useSelector((state: any) => state.agency.agency.data);
    const { user, userError } = useSelector((state: any) => state.login);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const formattedStartDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
    const formattedEndDate = new Date();
    const [startdate, setStartDate] = useState<string>(formattedStartDate.toISOString().split('T')[0]);
    const [enddate, setEndDate] = useState<string>(formattedEndDate.toISOString().split('T')[0]);
    const [col3, setCol3] = useState(true);
    const [expand, setExpand] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [editContact, setEditContact] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [phoneError, setPhoneError] = useState<string | null>(null);
    const [billingLoading, setBillingLoading] = useState(true);
    const [proposalsLoading, setProposalsLoading] = useState(true);
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortField, setSortField] = useState<string>('');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');


    const [date, setDate] = useState({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        key: "selection",
    });
    const [billingModalOpen, setBillingModalOpen] = useState(false);
    const [billingContacts, setBillingContacts] = useState<BillingContact[]>([]);
    const [billingData, setBillingData] = useState({
        FirstName: '',
        LastName: '',
        email: '',
        title: '',
        phone: '',
        sf_id: 0
    });
    const [editedBillingData, setEditedBillingData] = useState({
        FirstName: '',
        LastName: '',
        email: '',
        title: '',
        phone: '',
        sf_id: 0
    });
    const clearValidationErrors = () => {
        setEmailError('');
        setFirstNameError('');
        setLastNameError('');
        setTitleError('');
        setPhoneError(null);
    };
    useEffect(() => {
        if (location.state?.message) {
            setAlertMessage(location.state.message);
            setShowAlert(true);
            // Hide the alert after 5 seconds
            setTimeout(() => {
                setShowAlert(false);
                navigate(location.pathname, { replace: true, state: {} });
            }, 5000);
        }
    }, [location.state]);



    const fetchBillingContacts = useCallback(async () => {
        if (!agencyData?.Id) {
            return;
        }

        try {
            setBillingLoading(true); // Make sure loading starts

            const response = await axiosInstance.get('/billing-contacts', {
                params: {
                    account_ids: [agencyData.Id],
                },
            });
            //   setAccountInfo(response.data[0]);
            setBillingContacts(response?.data[0].billing_contacts);
            //Lazy loader for billing Contact
            const minLoadTime = 500;
            await new Promise(resolve => setTimeout(resolve, minLoadTime));
        } catch (error) {
            console.error('Error fetching billing contacts:', error);
            setBillingContacts([]);
        } finally {
            setBillingLoading(false);
        }
    }, [agencyData?.Id]);

    useEffect(() => {
        if (agencyData?.Id) { // Only run if we have the agency ID
            fetchBillingContacts();
        }
    }, [agencyData?.Id, fetchBillingContacts]);

    //to collapse the extra height to container on datepicker close
    const datePickerRef = useRef<HTMLDivElement>(null);;
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
                setExpand(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    usePageAccess(PAGE_ACCESS_TYPES.AGENCY_ADMIN_ONLY)
    useEffect(() => {

        const fetchProposalsWithLoading = async () => {
            setProposalsLoading(true);

            // Dispatch the original action
            // await dispatch(getProposals(user.user.users_id, agency.data.Id, startdate, enddate));
            await dispatch(getProposals(
                user.user.users_id, 
                agency.data.Id, 
                startdate, 
                enddate,
                sortField,
                sortDirection
            ));

            const minLoadTime = 500;
            await new Promise(resolve => setTimeout(resolve, minLoadTime));

            setProposalsLoading(false);
        };
        fetchProposalsWithLoading();
    }, [dispatch, agency.data.agency_id, navigate, date, sortField, sortDirection]);

    const handleSort = (column: any) => {
        const field = column.selector ? column.selector.toString().split('.').pop() : '';
        
        if (sortField === field) {
            // Toggle direction if same field
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            // New field, default to ascending
            setSortField(field);
            setSortDirection('asc');
        }
        
        // Reset to first page when sorting changes
        setCurrentPage(1);
    };

    const columns = [
        {
            name: "Order Name",
            selector: (row: Proposal) => row.order_name_c,
            cell: (row: Proposal) => {
                return (
                    <div
                        title={row.order_name_c} // Tooltip shows full amount
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block',  // Ensures ellipsis works
                            verticalAlign: 'middle',
                            cursor: 'default'         // Optional: show pointer or default
                        }}
                    >
                        {row.order_name_c}
                    </div>
                );
            },
            sortable: true,
            width: '350px',
        },
        {
            name: "Start Date",
            selector: (row: Proposal) => row.start_date,
            sortable: true,
            width: '150px',
        },
        {
            name: "End Date",
            selector: (row: Proposal) => row.end_date,
            sortable: true,
            width: '150px',
        },
        {
            name: "Amount",
            selector: (row: Proposal) => row.amount,
            cell: (row: Proposal) => {
                const formattedAmount = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(row.amount);

                return (
                    <div
                        title={formattedAmount} // Tooltip shows full amount
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '140px',         // Must be fixed
                            display: 'inline-block',  // Ensures ellipsis works
                            verticalAlign: 'middle',
                            cursor: 'default'         // Optional: show pointer or default
                        }}
                    >
                        {formattedAmount}
                    </div>
                );
            },
            sortable: true,
        },
        {
            name: "AE Name",
            selector: (row: Proposal) => row.user_name,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row: Proposal) => (row.status == 'pending signature') ? 'Pending Signature' : row.status,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row: Proposal) => (
                <div className="d-flex">
                    {!row.manual_order && (
                        <button
                            style={{ border: "none", backgroundColor: "transparent" }}
                            onClick={() => {
                                navigate("/view_proposal", { state: { proposals: row } });
                            }}
                            title="View Proposal"
                        >
                            <i className="fa fa-eye font-size-16 me-1"></i>
                        </button>
                    )}
                </div>
            ),
            width: '100px',
        },
    ];
    const customStyles = {
        tableWrapper: {
            style: {
                borderBottom: '1px solid #ced4da61',
            },
        },
        pagination: {
            style: {
                borderTop: '1px solid #ced4da61',
            },
        },
    };

    //searching in proposals and invoices
    const filteredProposals = proposals?.data.filter((item: any) => {
        // Skip rows with empty or whitespace-only order_name_c
        if (!item.order_name_c || item.order_name_c.trim() === "") {
            return false;
        }
        const topLevelMatch = Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        );

        const subTableMatch = item.invoices?.some((invoice: any) =>
            Object.values(invoice).some((invVal: any) =>
                String(invVal).toLowerCase().includes(searchTerm.toLowerCase())
            )
        );

        return topLevelMatch || subTableMatch;
    });

    const totalPages = Math.ceil(filteredProposals?.length / pageSize);

    // Compute items for current page
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredProposals?.slice(startIndex, endIndex);


    const handleDateChange = (ranges: any) => {
        setDate(ranges.selection);
        const formattedStartDate = ranges.selection.startDate.toLocaleDateString('en-CA');
        const formattedEndDate = ranges.selection.endDate.toLocaleDateString('en-CA');
        setStartDate(formattedStartDate);
        setEndDate(formattedEndDate);
        setExpand(false);
    };

    const handleEditClick = (contact: any) => {
        const mappedData = {
            FirstName: contact.first_name || '',
            LastName: contact.last_name || '',
            email: contact.email || '',
            title: contact.title || '',
            phone: contact.phone || '',
            sf_id: contact.id || ''
        };

        setBillingData(mappedData);
        setEditedBillingData(mappedData);
        clearValidationErrors();
        setBillingModalOpen(true);
    };
    const toggleBillingModal = () => {
        if (billingModalOpen) {
            // Clear all validation errors when closing modal
            clearValidationErrors();

            // Reset form data to original values
            setEditedBillingData(billingData);
        }
        setBillingModalOpen(!billingModalOpen);
    };
    const validateEmail = (email: string) => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

        // Reject if contains consecutive dots anywhere
        if (/\.\./.test(email)) return "Email cannot contain consecutive dots.";

        // Reject if contains a slash
        if (/[\/\\]/.test(email)) return "Email cannot contain slashes.";
        if (!emailRegex.test(email)) return "Please enter a valid email address.";

        // return emailRegex.test(email);
        return true;
    };
    const handleBillingChange = (e: any) => {
        const { name, value } = e.target;
        if (name === "email") {
            const result = validateEmail(value);
            if (result !== true) {
                setEmailError(result); // shows the specific reason
            } else {
                setEmailError("");
            }
        }

        if (name === "FirstName") {
            // Only allow alphabetic characters and spaces
            const filteredValue = value.replace(/[^A-Za-z\s]/g, '');

            if (!filteredValue || filteredValue.trim() === '') {
                setFirstNameError("This field is required.");
            } else {
                setFirstNameError("");
            }

            setEditedBillingData({ ...editedBillingData, FirstName: filteredValue });
            return;
        }

        if (name === "LastName") {
            // Only allow alphabetic characters and spaces
            const filteredValue = value.replace(/[^A-Za-z\s]/g, '');

            if (!filteredValue || filteredValue.trim() === '') {
                setLastNameError("This field is required.");
            } else {
                setLastNameError("");
            }

            setEditedBillingData({ ...editedBillingData, LastName: filteredValue });
            return;
        }

        if (name === "phone") {
            const numericValue = value.replace(/\D/g, "");

            if (!numericValue) {
                setPhoneError("This field is required.");
            } else {
                setPhoneError(null);
            }

            // Store only the numeric value
            setEditedBillingData({
                ...editedBillingData,
                phone: numericValue,
            });
            return;
        }
        setEditedBillingData({ ...editedBillingData, [e.target.name]: e.target.value });
    };
    const handlePhoneChange = (mobile: string | '', modalName: string) => {
        setPhoneNumber(mobile);
        switch (modalName) {
            case 'billing': setEditedBillingData({
                ...editedBillingData,
                phone: mobile || ''
            });
                break;
            default: break;
        }
        setPhoneError(null);
    }
    const checkDuplicateEmail = async (email: string, sfId: number) => {
        try {
            const response = await axiosInstance.post('/check-duplicate-email-billing', {
                email: email,
                sf_id: sfId
            });
            return response.data.data.exists;
        } catch (error) {
            console.error('Error checking duplicate email:', error);
            return false;
        }
    };
    const handleBillingUpdate = async () => {

        // Compare values of matching keys
        const updatedFields = Object.fromEntries(
            Object.entries(editedBillingData).filter(([key, value]) => value !== billingData[key as keyof typeof billingData])
        );


        // Check if any changes exist
        if (Object.keys(updatedFields).length === 0) {
            toast.info("No changes to update.");
            setBillingModalOpen(false);
            return;
        }

        // Validate email
        // const result = validateEmail(editedBillingData.email || '');
        // if (result !== true) {
        //     setEmailError(result);
        //     return;
        // } else {
        //     setEmailError('');
        // }
        const result = validateEmail(editedBillingData.email || '');
        if (result !== true) {
            setEmailError(result);
            return;
        } else {
            // Check for duplicate email only if email has changed
            if (editedBillingData.email !== billingData.email) {
                const isDuplicate = await checkDuplicateEmail(editedBillingData.email, editedBillingData.sf_id);
                if (isDuplicate) {
                    setEmailError("This email is already in use. Please enter another email.");
                    return;
                }
            }
            setEmailError('');
        }

        if (!editedBillingData.FirstName || editedBillingData.FirstName.trim() === '') {
            setFirstNameError("This field is required.");
            return;
        }

        if (!editedBillingData.LastName || editedBillingData.LastName.trim() === '') {
            setLastNameError("This field is required.");
            return;
        }
        const cleanPhone = (editedBillingData.phone || '').replace(/\D/g, '');

        if (!cleanPhone) {
            setPhoneError("This field is required.");
            return;
        }

        if (cleanPhone.length !== 10) {
            setPhoneError("Phone number must be exactly 10 digits");
            return;
        }

        axiosInstance.post(`/update-billing-info`, {
            ...editedBillingData,
            phone: cleanPhone // Ensure we send only numeric digits
        })
            .then((response) => {
                toast.success("Billing information updated.");
                setBillingModalOpen(false);
                fetchBillingContacts();
            })
            .catch((error) => {
                toast.error("Something Went Wrong!");
            });
    };

    const isMobile = useIsMobile();
    const [openAccordions, setOpenAccordions] = useState<number[]>([]);

    const toggleAccordion = (id: number) => {
        setOpenAccordions((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const formatPhoneNumber = (value: string) => {
        if (!value) return "";
        const cleaned = value.replace(/\D/g, ""); // only digits
        const length = cleaned.length;

        if (length < 4) return cleaned;
        if (length < 7) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
        return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };


    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: "0" }}>
                <Navbar />
                <Container fluid style={{ overflow: 'visible', marginTop: "10px" }}>
                    <Breadcrumbs title="Setting" breadcrumbItem="Billing Info" titleLink="/branding" showLeftTitle={false}/>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <div className="row pb-2"><span><b style={{ fontSize: "18px" }}>Billing Info</b></span></div>
                                        <Col xl={12}>
                                            <div className="accordion" id="accordionExample">
                                                <div className="accordion-item">
                                                    <Collapse isOpen={col3} className="accordion-collapse">
                                                        {billingLoading ? (
                                                            <BillingCardLoader />
                                                        ) : billingContacts.length > 0 ? (
                                                            <div className="card shadow-sm" style={{ marginBottom: "0px" }}>
                                                                <div className="card-header d-flex justify-content-between align-items-center bg-light">
                                                                    <h5 className="mb-0">{agencyData?.Name || "Billing Contact"}</h5>
                                                                    <i
                                                                        className="mdi mdi-pencil font-size-16 text-primary"
                                                                        onClick={() => handleEditClick(billingContacts[0])}
                                                                        title="Edit"
                                                                        style={{ cursor: "pointer", display: "inline-block" }}
                                                                    ></i>
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-4 g-md-5">
                                                                        <div className="col d-grid">
                                                                            <label className="d-block" style={{ marginBottom: "4px" }}>First Name</label>
                                                                            <div className="text-muted"
                                                                                title={(billingContacts[0]?.first_name?.trim() || "-")}
                                                                                style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '150px',
                                                                                }}
                                                                            >{(billingContacts[0]?.first_name?.trim() || "-")}</div>
                                                                        </div>
                                                                        <div className="col d-grid">
                                                                             <label className="d-block" style={{ marginBottom: "4px" }}>Last Name</label>
                                                                            <div className="text-muted"
                                                                                title={billingContacts[0]?.last_name?.trim() || "-"}
                                                                                style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '150px',
                                                                                }}
                                                                            >{billingContacts[0]?.last_name?.trim() || "-"}</div>
                                                                        </div>
                                                                        <div className="col d-grid">
                                                                             <label className="d-block" style={{ marginBottom: "4px" }}>Email</label>
                                                                            <div className="text-muted"
                                                                                title={billingContacts[0]?.email?.trim() || "-"}
                                                                                style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '150px',
                                                                                }}
                                                                            >{billingContacts[0]?.email?.trim() || "-"}</div>
                                                                        </div>
                                                                        <div className="col d-grid">
                                                                             <label className="d-block" style={{ marginBottom: "4px" }}>Phone</label>
                                                                            <div className="text-muted"
                                                                                title={formatPhoneNumber(billingContacts[0]?.phone) || "-"}
                                                                                style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '150px',
                                                                                }}
                                                                            >{formatPhoneNumber(billingContacts[0]?.phone) || "-"}</div>
                                                                        </div>
                                                                        <div className="d-grid">
                                                                            <label className="d-block" style={{ marginBottom: "4px" }}>Title</label>
                                                                            <div className="text-muted"
                                                                                title={billingContacts[0]?.title?.trim() || "-"}
                                                                                style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '150px',
                                                                                }}
                                                                            >{billingContacts[0]?.title?.trim() || "-"}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                                                                <p className="text-muted mb-0">No contacts to display.</p>
                                                            </div>
                                                        )}

                                                    </Collapse>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody className="pb-0">
                                    {showAlert && (
                                        <UncontrolledAlert color="danger">
                                            {alertMessage}
                                        </UncontrolledAlert>
                                    )}
                                    <div className="d-flex flex-column flex-sm-row align-items-start gap-3 mb-4">
                                        <div className="w-100 w-sm-auto responsive-input" >
                                            <Input
                                                type="text"
                                                placeholder="Search by Invoice Name/Order Name"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="w-100 w-sm-auto responsive-input" ref={datePickerRef}>
                                            <span onClick={() => setExpand(true)} className="d-block w-100">
                                                <CustomDatePicker date={date} handleDateChange={handleDateChange} />
                                            </span>
                                        </div>
                                    </div>
                                    {proposalsLoading ? (
                                        <div className="table-container" >
                                            <TableCustomLoader length={2}
                                                message="Almost ready! Finalizing Billing data." />
                                        </div>
                                    ) : filteredProposals && filteredProposals.length > 0 ? (
                                        <div className="mb-4">
                                            {!isMobile ?
                                                <DataTable
                                                    className="billing-table data-table"
                                                    columns={columns}
                                                    data={paginatedData}
                                                    responsive
                                                    expandableRows
                                                    expandableRowsComponent={ExpandedComponent}
                                                    sortServer
                                                    onSort={handleSort}
                                                /> :
                                                <div className="d-block d-md-none mobile-cards-container">
                                                    {paginatedData.map((order: any) => {
                                                        return (
                                                            <div className='mobile-card card' key={order.id}>
                                                                <div className=" d-flex flex-row gap-2" >
                                                                    <span onClick={() => toggleAccordion(order.id)} style={{ cursor: "pointer" }}>
                                                                        <img
                                                                            src="/assets/icons/dropdown.svg"
                                                                            alt="Dropdown Icon"
                                                                            className={`nav-icon ${openAccordions.includes(order.id) ? "" : "rotate-90"}`}
                                                                        />
                                                                    </span>
                                                                    <div>
                                                                        <div className='d-flex flex-column gap-2'>
                                                                            <div
                                                                                className="orders-mobile-card-row"
                                                                            >
                                                                                <span className="row-title fw-bold">
                                                                                    Order Name
                                                                                </span>
                                                                                <span className="row-value">
                                                                                    {order.order_name_c}
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                className="orders-mobile-card-row "
                                                                            >
                                                                                <span className="row-title fw-bold">
                                                                                    Start Date
                                                                                </span>
                                                                                <span className="row-value">
                                                                                    {order.start_date}
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                className="orders-mobile-card-row "

                                                                            >
                                                                                <span className="row-title fw-bold">
                                                                                    End Date
                                                                                </span>
                                                                                <span className="row-value">
                                                                                    {order.end_date}
                                                                                </span>

                                                                            </div>
                                                                            <div
                                                                                className="orders-mobile-card-row "

                                                                            >
                                                                                <span className="row-title fw-bold">
                                                                                    AE Name
                                                                                </span>
                                                                                <span className="row-value">
                                                                                    {order.user_name}
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                className="orders-mobile-card-row "

                                                                            >
                                                                                <span className="row-title fw-bold">
                                                                                    Status
                                                                                </span>
                                                                                <span className="row-value">
                                                                                    {order.status}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                        {openAccordions.includes(order.id) && (
                                                                            <div className="d-block d-md-none mobile-cards-container" style={{ marginLeft: "-30px", marginTop: "20px" }}>
                                                                                {order.invoices.length > 0 ? (
                                                                                    order.invoices.map((invoice: any, idx: number) => (
                                                                                        <div key={idx} className="mobile-card card">
                                                                                            {/* invoice details here */}
                                                                                            <div
                                                                                                className="orders-mobile-card-row "

                                                                                            >
                                                                                                <span className="row-title fw-bold">
                                                                                                    Invoice Number
                                                                                                </span>
                                                                                                <span className="row-value">
                                                                                                    {invoice.invoice_number}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div
                                                                                                className="orders-mobile-card-row "

                                                                                            >
                                                                                                <span className="row-title fw-bold">
                                                                                                    Invoice Name
                                                                                                </span>
                                                                                                <span className="row-value">
                                                                                                    {invoice.order_name}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div
                                                                                                className="orders-mobile-card-row "

                                                                                            >
                                                                                                <span className="row-title fw-bold">
                                                                                                    Date Issue
                                                                                                </span>
                                                                                                <span className="row-value">
                                                                                                    {invoice.invoice_create_date}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div
                                                                                                className="orders-mobile-card-row "
                                                                                            >
                                                                                                <span className="row-title fw-bold">
                                                                                                    Due Date
                                                                                                </span>
                                                                                                <span className="row-value">
                                                                                                    {invoice.invoice_due_date}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div
                                                                                                className="orders-mobile-card-row "
                                                                                            >
                                                                                                <span className="row-title fw-bold">
                                                                                                    Invoice Total
                                                                                                </span>
                                                                                                <span className="row-value">
                                                                                                    {invoice.invoice_amount}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))
                                                                                ) : (
                                                                                    <p className="text-muted">No invoices available</p>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    className="btn btn-primary mt-3 button-primary view-btn"
                                                                    type="submit"
                                                                    onClick={() => {
                                                                        navigate("/view_proposal", { state: { proposals: order } });
                                                                    }}
                                                                >
                                                                    View
                                                                </button>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            }
                                            {/* Pagination */}
                                            <Pagination
                                                totalPages={totalPages}
                                                currentPage={currentPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                                currentCount={paginatedData.length}
                                                pageSize={pageSize}
                                                onPageSizeChange={(size) => {
                                                    setPageSize(size);
                                                    setCurrentPage(1); // reset to first page
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                                            <p className="text-muted mb-0">There are no records to display.</p>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal isOpen={billingModalOpen} toggle={toggleBillingModal} modalClassName={"general-custom-modal"}>
                        <ModalHeader toggle={toggleBillingModal}>Edit Billing Contact</ModalHeader>
                        <ModalBody>
                            <FormGroup className="mb-2">
                                <label className="form-label">First Name</label>
                                <input
                                    type="text"
                                    className={`form-control ${firstNameError ? "is-invalid" : ""}`}
                                    name="FirstName"
                                    value={editedBillingData.FirstName || ''}
                                    onChange={handleBillingChange} />
                                {firstNameError && <div className="invalid-feedback">{firstNameError}</div>}
                            </FormGroup>
                            <FormGroup className="mb-2">
                                <label className="form-label">Last Name</label>
                                <input
                                    type="text"
                                    className={`form-control ${lastNameError ? "is-invalid" : ""}`}
                                    name="LastName"
                                    value={editedBillingData.LastName || ''}
                                    onChange={handleBillingChange} />
                                {lastNameError && <div className="invalid-feedback">{lastNameError}</div>}
                            </FormGroup>
                            <FormGroup className="mb-2">
                                <label className="form-label">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${titleError ? 'is-invalid' : ''}`}
                                    name="title"
                                    value={editedBillingData.title || ''}
                                    onChange={handleBillingChange}
                                    required
                                    maxLength={500}
                                />
                            </FormGroup>
                            <FormGroup className="mb-2">
                                <label className="form-label">Email</label>
                                <input type="email"
                                    className={`form-control ${emailError ? 'is-invalid' : ''}`}
                                    name="email" value={editedBillingData.email || ''} onChange={handleBillingChange} />
                                {emailError && <div className="invalid-feedback">{emailError}</div>}
                            </FormGroup>
                            <FormGroup className="mb-2">
                                <Label for="Phone">Phone</Label>
                                {/*<PhoneInput
                                    value={normalizePhoneNumber(editedBillingData.phone)}
                                    onChange={(phone) => handlePhoneChange(phone, 'billing')}
                                    inputStyle={{ width: '100%' }}
                                />*/}
                                <Input
                                    id="phone"
                                    name="phone"
                                    type="tel"
                                    value={formatPhoneNumber(editedBillingData.phone || "")} // show formatted
                                    onChange={handleBillingChange}
                                    className={`form-control ${phoneError ? "is-invalid" : ""}`}
                                    maxLength={12} // 10 digits + 2 dashes
                                    inputMode="numeric"
                                    placeholder="Enter phone number"
                                />
                                {phoneError && (
                                    <div style={{ color: 'red', fontSize: '0.85rem', marginTop: '0.25rem' }}>
                                        {phoneError}
                                    </div>)}
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <div className="d-flex gap-3 justify-content-end">
                                <button className="btn btn-primary button-primary w-100 w-sm-auto" onClick={handleBillingUpdate}>Update</button>
                                <button className="btn btn-danger button-secondary w-100 w-sm-auto" style={{
                                    border: '1px solid #686868',
                                    width: '88px'
                                }} onClick={() => setBillingModalOpen(false)}>Cancel</button>
                            </div>
                        </ModalFooter>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Billing;
